import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { propertyHierarchy } from '../endpoints';

import { TestWidgetWrapper } from './wrapper.tsx';
import { TestWidgetKnobs } from './knobs.jsx';

export const config = {
	key: 'TEST_WIDGET',
	label: 'Test Widget',
	icon: 'doughnut-chart',
	wrapper: TestWidgetWrapper,
	endpoint: propertyHierarchy,
	Knobs: TestWidgetKnobs,
	flags: [SrsPropertyFlag.Categorical],
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name, filteredProperties[1].name],
				parameters: {},
			},
		};
	},
};
